var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.4502 14.416H14.5771C15.4902 14.416 16.0273 13.9541 16.0273 13.2666C16.0273 12.4287 15.1465 11.6553 14.4053 10.9141C13.9219 10.4307 13.7285 9.43164 13.707 8.67969C13.6963 5.19922 12.8369 2.84668 10.5381 1.96582C10.1836 0.891602 9.30273 0 8.01367 0C6.72461 0 5.84375 0.891602 5.48926 1.96582C3.19043 2.84668 2.33105 5.19922 2.30957 8.67969C2.29883 9.43164 2.09473 10.4307 1.62207 10.9141C0.870117 11.6553 0 12.4287 0 13.2666C0 13.9541 0.537109 14.416 1.4502 14.416ZM8.01367 17.9502C9.48535 17.9502 10.5596 16.876 10.6562 15.6621H5.37109C5.45703 16.876 6.54199 17.9502 8.01367 17.9502Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell_icon.b87b9167387d10e412736037f9ac4612.svg";
export { ForwardRef as ReactComponent };